import React from 'react'
import {
  Link as RouterLink,
  LinkProps as RouterLinkProps,
} from 'react-router-dom'

interface LinkProps extends RouterLinkProps {
  variant?: 'primary' | 'secondary' | 'danger'
  children: React.ReactNode
}

const Link: React.FC<LinkProps> = ({
  variant = 'primary',
  className = '',
  children,
  ...props
}) => {
  const variantClasses = {
    primary: 'text-blue-600 hover:text-blue-100',
    secondary: 'text-gray-600 hover:text-gray-500',
    danger: 'text-red-800 hover:text-red-900',
  }

  const classes = `font-medium ${variantClasses[variant]} ${className}`.trim()

  return (
    <RouterLink className={classes} {...props}>
      {children}
    </RouterLink>
  )
}

export default Link
